import { Link } from "react-router-dom";
import { Sparkle, Aperture, Asterisk, X, Fish } from "lucide-react";

export const Logo = ({ to = "/", small = false }) => (
  <Link to={to} data-testid="brand-logo" className="flex items-center gap-2 sm:gap-2.5 group min-w-0">
    <img src="/logo.png" alt="Aurora ON" className={`${small ? "w-8 h-8" : "w-9 h-9 sm:w-10 sm:h-10"} shrink-0 rounded-xl shadow-[0_0_18px_rgba(45,212,191,0.45)] group-hover:shadow-[0_0_28px_rgba(45,212,191,0.7)] transition-shadow duration-300`} />
    <span className={`font-heading font-bold whitespace-nowrap ${small ? "text-lg tracking-[0.18em]" : "text-base sm:text-xl tracking-[0.12em] sm:tracking-[0.18em]"} text-white`}>
      AURORA <span className="text-aurora">ON</span>
    </span>
  </Link>
);

const KimiK = () => <span className="font-heading font-bold text-lg leading-none">K</span>;

export const MODEL_CHIPS = [
  { id: "gemini", name: "Gemini", Icon: Sparkle, color: "#60A5FA" },
  { id: "gpt", name: "ChatGPT", Icon: Aperture, color: "#34D399" },
  { id: "claude", name: "Claude", Icon: Asterisk, color: "#F59E0B" },
  { id: "grok", name: "Grok", Icon: X, color: "#F8FAFC" },
  { id: "kimi", name: "Kimi", Icon: KimiK, color: "#A78BFA" },
  { id: "deepseek", name: "DeepSeek", Icon: Fish, color: "#22D3EE" },
];

export const ModelLogos = () => (
  <div className="flex flex-wrap justify-center gap-2.5 sm:gap-3" data-testid="model-logos-row">
    {MODEL_CHIPS.map(({ id, name, Icon, color }, i) => (
      <div key={id} data-testid={`model-logo-${id}`} style={{ animationDelay: `${0.6 + i * 0.08}s` }}
        className="fade-up flex items-center gap-2 px-3.5 py-2 rounded-full border border-cyan-500/20 bg-[#0a1224]/70 backdrop-blur-xl hover:border-emerald-400/50 hover:-translate-y-0.5 transition-[transform,border-color] duration-300">
        <span style={{ color }} className="flex w-5 h-5 items-center justify-center"><Icon size={18} /></span>
        <span className="text-xs font-mono tracking-[0.15em] uppercase text-slate-300">{name}</span>
      </div>
    ))}
  </div>
);
